import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=5fa72809&scoped=true&"
import script from "./Admin.vue?vue&type=script&lang=js&"
export * from "./Admin.vue?vue&type=script&lang=js&"
import style0 from "./Admin.vue?vue&type=style&index=0&id=5fa72809&prod&lang=css&"
import style1 from "./Admin.vue?vue&type=style&index=1&id=5fa72809&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa72809",
  null
  
)

export default component.exports